import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  imports: [CommonModule],
  selector: 'aux-card',
  templateUrl: 'card.component.html',
})
export class CardComponent {
  @Input() bottomTemplate?: TemplateRef<unknown>;
  @Input() className?: string;
  @Input() middleText?: number | string;
  @Input() topText?: string;
}
